import React, { useState, useEffect }  from "react";
import socketIOClient from "socket.io-client";
import { URLS, httpUploadFile } from "./../network";
import download from "downloadjs";
import './../css/background.css';
import { SCRAPING_PAGE_TYPE, isNullOrEmpty, toObject } from "./../utils";

const SoyChile = (props) => {

    const [showLoader, setShowLoader] = useState(false);
    const [fileSelector, setFileSelector] = useState(null);
    const [fileObj, setFileObj] = useState({filePath: "", fileName: "" });
    const [currentRow, setCurrentRow] = useState(0);
    const [maxRows, setMaxRows] = useState(0);
    const [rowsData, setRowsData] = useState([]);

    useEffect( () => {

        setFileSelector(buildFileSelector());
    }, []);

    const buildFileSelector = () => {
		
        const tmpFileSelector = document.createElement("input");
        tmpFileSelector.setAttribute("type", "file");
        tmpFileSelector.setAttribute("multiple", "multiple");
    
        tmpFileSelector.onchange = parseFile();
        return tmpFileSelector;
    };

    const parseFile = () => (e) => {

        const file = e.target.files[0];   
        httpUploadFile(URLS.UPLOAD_FILE, { newFile: file})
            .then ( (data) => {
                
                setFileObj({filePath: data.path, fileName: data.realname });
            })
            .catch ((err) => {
                console.log ("err: ", err);
            });
    };
        
    const onFileClickSelect = (e) => {
        e.preventDefault();
        fileSelector.click();
    };

    const downloadFileResult = (filename) => {

        fetch(URLS.DOWNLOAD_FILE + "?file="+filename)
            .then ((res) => {
                return res.blob();
            })
            .then ( (blob) => {
                download(blob, "soychile_coincidencias.txt", "text/plain");
            })
            .catch( (err) => {
                console.log (err);
            });
    }

    const onProcessClick = (e) => {

        const socket = socketIOClient(URLS.MAIN_URL, {  query: "type="+ SCRAPING_PAGE_TYPE.SoyChile});
        socket.on("connection", (data) => {
            console.log (data)
        });

        socket.on("on_row_incoming", (data) => {

            const payload = toObject(data);
            if (!payload || !payload.tender) {
                return;
            }

            setCurrentRow(payload.row);
            setRowsData(prev => [...prev, payload.tender]);
        });

        socket.on("on_error", (errObj) => {

            setShowLoader(false);
            setMaxRows(0);
            setCurrentRow(0);

            const err = errObj.err;
            this.props.errorMessage(err.message);
            socket.emit("disconnect");
            socket.disconnect();

            if ( !isNullOrEmpty(errObj.file)) {
                downloadFileResult(errObj.file);
            }
        });

        socket.on ("on_process_end", (filename) => {

            socket.emit("disconnect");
            socket.disconnect();

            console.log ("on_process_end: ", filename);
            setShowLoader(false);
            downloadFileResult(filename);          
        });

        socket.on("on_rows_to_proccess", (rowsNumber) => {
            setMaxRows(rowsNumber);
        })

        setCurrentRow(0);
        setRowsData([]);
        setShowLoader(true);

        const params = { 
            path: fileObj.filePath
        };

        socket.emit("process_start", params);
    }

    return (
        <div className="pjud-container">
        <h3>Soy Chile - Búsqueda Avanzada</h3>
        <p>
           Búsqueda de palabras cláves dentro de normas en el sitio <b>Soy Chile</b> segun rango de fechas.
            <a href={URLS.MAIN_URL + "assets/soy_chile_ejemplo.xml"} target="_blank" rel="noopener noreferrer">
                <span className="fas fa-file-excel pjud-excel-icon" title="Documento de ejemplo"></span>
            </a>
        </p>
        
        <div className="pjud-option-container">
            <fieldset className="scheduler-border" >
                <legend className="scheduler-border">Selecciona el archivo con las palabras cláves a buscar</legend>
                <div className="filter-doc-file">
                    <input type="text" id="filterIdsTxt" className="form-control"
                        placeholder="Selecciona archivo" value={fileObj.fileName} />
                    <button className="btn btn-outline-primary" onClick={onFileClickSelect}> Abrir</button>
                </div>
            </fieldset>
            
        </div>

        <div className="progress-container">
            
            <div className="progress-state">
                { showLoader && <div id="loader" className="loader-seia"></div> }
                <label id="currentProgress">{"Leido " + 0 + " de " + 0}</label>
            </div>
            <div className="pjud-btn-containers">
                <button className="btn btn-outline-primary" onClick={onProcessClick} >Buscar</button>
            </div>
            
        </div>
        
        <div id="tableContainer" className="result-table">
            <table className="table table-striped table-fixed">
                <thead>
                    <tr>
                        <th scope="col">ID</th>
                        <th scope="col">Titulo</th>
                        <th scope="col">URL</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        rowsData.map( (row, index) => {
                            
                            return (
                                <tr key={index}>
                                    <td className="first-table-row">{row.id}</td>
                                    <td>{row.title}</td>
                                    <td><a href={row.url }>{row.url }</a></td>
                                </tr>
                            );
                        })   
                    }
                
                </tbody>
            </table>
        </div>
    </div>
    );
};

export default SoyChile;